import React from 'react';
import SEO from "../../common/SEO";
import Layout from "../../common/Layout";
import BreadcrumbOne from "../breadcrumb/BreadcrumbOne";
import SectionTitle from "../sectionTitle/SectionTitle";
import ContactOne from "./ContactOne";

const Contact = ({ showFooter }) => {
    return (
        <>
            <SEO title="Contact || WhatsOn Agency " />
            <Layout>
                <BreadcrumbOne 
                    title="The Easiest Way To Create Website <br /> Contact US."
                    rootUrl="/"
                    parentUrl="Home"
                    currentUrl="Contact"
                />
                <div className="main-content">
                    {/* Start Contact Area */}
                    <div className="rwt-contact-area rn-section-gap" role="region" aria-label="Contact information section">
                        <div className="container">
                            <div className="row">
                                <div className="col-lg-12 mb--40">
                                    <SectionTitle
                                        textAlign="text-center"
                                        radiusRounded=""
                                        subtitle="Contact Info"
                                        title="Our Contact Address Here."
                                        description=""
                                    />
                                </div>
                            </div>
                            <ContactOne />
                        </div>
                    </div>
                    {/* End Contact Area */}
                   
               
                </div>
            </Layout>
        </>
    );
}

export default Contact;
